/**
 * The different pages where Conductor components can be shown
 */
export enum ConductorPageType {
  CONDUCTOR_PAGE_TYPE_UNKNOWN = 'CONDUCTOR_PAGE_TYPE_UNKNOWN',
  CONDUCTOR_HOME_PAGE = 'CONDUCTOR_HOME_PAGE',
  CONDUCTOR_DISCOVER = 'CONDUCTOR_DISCOVER',
  CONDUCTOR_PDP = 'CONDUCTOR_PDP',
  CONDUCTOR_BRAND = 'CONDUCTOR_BRAND',
  CONDUCTOR_CATEGORY = 'CONDUCTOR_CATEGORY',
}
